import React from 'react';

import type { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core';
import styles from './styles';

import { computed } from 'mobx';

interface IProps extends WithStyles<typeof styles> {
  status?: string;
}

class Status extends React.Component<IProps> {
  static readonly defaultProps: Partial<IProps> = {
    status: ''
  };

  render() {
    const { status } = this.props;

    if (this.show) {
      return null;
    }

    return <span className={this.className}>{status}</span>;
  }

  @computed
  private get show(): boolean {
    const { status } = this.props;

    return window.location.pathname.toLowerCase() !== '/myaccount/packages' || !status;
  }

  @computed
  private get className(): string {
    const { classes, status } = this.props;

    const cls = [classes.statusLabel];

    if (!!status) {
      switch (status.toLowerCase()) {
        case 'active':
          cls.push(classes.active);
          break;

        case 'expired':
          cls.push(classes.expired);
          break;

        case 'used':
          cls.push(classes.expired);
          break;
        default:
          break;
      }
    }

    return cls.join(' ');
  }
}

export default withStyles(styles)(Status);
